import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { LabelValue } from 'src/app/constants/general-constants';
import { ItemCounts } from 'src/app/constantsObjects';
import { Program } from 'src/app/model/cms-btv-core/program-model';
import moment from 'moment';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

declare var $: any;
@Injectable({
  providedIn: 'root',
})
export class Utility {
  randomSearch: any;
  status: string;
  processComment: string;
  programSearch: Program[];
  startTime: number;
  endTime: number;
  tempFiles: any[];
  result: any[];
  itemCount: LabelValue;
  itemCounts: LabelValue[] = ItemCounts;
  regSub = new RegExp(/\.(ttml|vtt|srt|pac|rar|zip)$/i);
  videoReg = new RegExp(/\.(mp4|avi|vcd|svcd|mpg|asf|wmv|mpeg|mov|dat|flv|mkv|mxf|mov|m2t|ts|m2ts|mpg2|mpeg2)$/i);
  audioReg = new RegExp(/\.(wav|mp3|m4a|flac|wma|aac|)$/i);
  meRegex = new RegExp(/\.(wav|mp3|m4a|flac|wma|aac|)$/i);
  trailerRegex = new RegExp(/\.(vtt|mxf|ttml)$/i);

  constructor(private location: Location) { }

  openModal(modalId: string): void {
    if (modalId !== '' && modalId !== null && modalId !== undefined) {
      $(`#${modalId}`).modal('show');
    }
  }

  /**close modal from static */
  closeModal(modalId: string): void {
    if (modalId !== '' && modalId !== null && modalId !== undefined) {
      $(`#${modalId}`).modal('hide');
      // $('.modal-backdrop').remove();
    }
  }

  closeContractModal(modalId: string): void {
    if (modalId !== '' && modalId !== null && modalId !== undefined) {
      $(`#${modalId}`).modal('hide');
      // $('.modal-backdrop').remove();
      this.location.back();
    }
  }

  closeModalInline(modalId: string): void {
    if (modalId !== '' && modalId !== null && modalId !== undefined) {
      $(`#${modalId}`).modal('hide');
      // $('.modal-backdrop').remove();
      this.location.back();
    }
  }
  closeModalInMethod(modalId: string): void {
    if (modalId !== '' && modalId !== null && modalId !== undefined) {
      $(`#${modalId}`).modal('hide');
      // $('.modal-backdrop').remove();
      this.location.back();
    }
  }

  /** Close Modal on any click   */
  closeModalOnAnyWhere(modalId: string): void {
    if (modalId !== '' && modalId !== null && modalId !== undefined) {
      $(`#${modalId}`).on('hidden.bs.modal', () => {
        this.location.back();
        $('.modal-backdrop').remove();
      });
    }
  }

  //* Search Object for back-end object *//
  searchObject(searchObjectArray?: any, event?: any): any {


    this.randomSearch = [];
    if (searchObjectArray && searchObjectArray.length > 0) {
      for (let i = 0; i < searchObjectArray.length; i++) {
        let currentSearch = searchObjectArray[i];

        if (currentSearch.name) {
          if (currentSearch.name.toUpperCase().trim().indexOf(event.query.toUpperCase().trim()) > -1) {
            this.randomSearch.push(currentSearch);
          }
        }
        else if (currentSearch.turkishName) {
          if (currentSearch.turkishName.toUpperCase().trim().indexOf(event.query.toUpperCase().trim()) > -1) {
            this.randomSearch.push(currentSearch);
          }
        }
        else if (currentSearch.title) {
          if (currentSearch.title.toUpperCase().indexOf(event.query.toUpperCase()) > -1) {
            this.randomSearch.push(currentSearch);
          }
        } else if (currentSearch.fileName) {
          if (currentSearch.fileName.toUpperCase().indexOf(event.query.toUpperCase()) > -1) {
            this.randomSearch.push(currentSearch);
          }
        } else if (currentSearch.label) {
          if (currentSearch.label.toUpperCase().indexOf(event.query.toUpperCase()) > -1) {
            this.randomSearch.push(currentSearch);
          }
        } else if (currentSearch.username) {
          if (currentSearch.username.toUpperCase().indexOf(event.query.toUpperCase()) > -1) {
            this.randomSearch.push(currentSearch);
          }
        } else if (currentSearch.programTitle) {
          if (currentSearch.programTitle.toUpperCase().indexOf(event.query.toUpperCase()) > -1) {
            this.randomSearch.push(currentSearch);
          }
        } else if (currentSearch.length) {
          if (currentSearch.toUpperCase().indexOf(event.query.toUpperCase()) > -1) {
            this.randomSearch.push(currentSearch);
          }
        } else if (currentSearch.languageName) {
          if (currentSearch.languageName.toUpperCase().indexOf(event.query.toUpperCase()) > -1) {
            this.randomSearch.push(currentSearch);
          }
        }
        else {
          this.randomSearch.push(currentSearch);
        }
        i;
      }
    }
  }
  /** search */
  search(searchArray: any, event: any): void {
    this.randomSearch = [];
    for (let i = 0; i < searchArray.length; i++) {
      let currentSearch = searchArray[i];
      //currentSearch.toLowerCase().indexOf(event.query.toLowerCase()) == 0 ? this.result.push(currentSearch) : null;
      if (currentSearch.toUpperCase().indexOf(event.query.toUpperCase()) > -1) {
        this.randomSearch.push(currentSearch);
      }
      i;
    }
  }
  remove(array: any[], item: any): any[] {
    let index: number = array.findIndex((key) => key === item);
    index != -1 ? array.splice(index, 1) : null;

    return array;
  }

  setBackGroundColor(program?: Program, tableId?: string, objectArray?: any[]): void {
    let index: number = objectArray.findIndex((item) => item.status == 'Deleted');

    let table = document.getElementById('programTable');
    let tr = table.getElementsByTagName('tr');
    let td = table.getElementsByTagName('td');

    for (const key in td) {
      if (Object.prototype.hasOwnProperty.call(td, key)) {
        const element = td[key];
        if (element.textContent == 'Deleted') {
          tr[index + 1].classList.add('bg-danger');
        } else if (element.textContent.includes('Updated')) {
          tr[index + 1].style.color = 'blue';
        }
      }
    }
  }

  processChecker(name: string, status: string, processData: any[]): any {
    for (const process of processData) {
      if (process.name + process.status == name + status) {
        this.status = process.name + process.status;
        this.processComment = process.comment;
        this.randomSearch = JSON.parse(process.processData);

        return true;
      }
    }
    return false;
  }

  copyPath(contentVfoFolder: string): void {
    let listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', 'video_operations_contents/' + contentVfoFolder);
      e.preventDefault();
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

  copyToClipboard(text: string): void {
    if (!text) return;
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text);
    } else {
      const el = document.createElement('textarea');
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.focus();
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  }

  setDraggable(): void {
    $('body')
      .on('mousedown', '.modal-dialog', function () {
        $(this)
          .addClass('draggable')
          .parents()
          .on('mousemove', function (e) {
            $('.draggable')
              .offset({
                top: e.pageY - $('.draggable').outerHeight() / 2,
                left: e.pageX - $('.draggable').outerWidth() / 2,
              })
              .on('mouseup', function () {
                $(this).removeClass('draggable');
              });
            e.preventDefault();
          });
      })
      .on('mouseup', function () {
        $('.draggable').removeClass('draggable');
      });
  }

  setTime(programTime?: number): void {
    $('#slider-range').slider({
      min: 0,
      max: 1440,
      step: 1,
      values: [programTime],
      slide: function (e, ui) {
        var hours = Math.floor(ui.values[0] / 60);
        var minutes = ui.values[0] - hours * 60;

        if (hours < 12) {
          hours = parseInt('0') + hours;
        }

        $('.slider-time').html(hours + ':' + minutes);
      },
    });
  }

  drawMenu(): void {
    $('#menu-toggle').click(function (e) {
      e.preventDefault();
      $('#wrapper').toggleClass('toggled');
    });
    $('#menu-toggle-2').click(function (e) {
      e.preventDefault();
      $('#wrapper').toggleClass('toggled-2');
      $('#menu ul').hide();
    });

    function initMenu() {
      $('#menu ul').hide();
      $('#menu ul').children('.current').parent().show();
      //$('#menu ul:first').show();
      $('#menu li a').click(function () {
        var checkElement = $(this).next();
        if (checkElement.is('ul') && checkElement.is(':visible')) {
          return false;
        }
        if (checkElement.is('ul') && !checkElement.is(':visible')) {
          $('#menu ul:visible').slideUp('normal');
          checkElement.slideDown('normal');
          return false;
        }
      });
    }
    $(document).ready(function () {
      initMenu();
    });
  }

  searchMediaFile(mediaFileArray: any[], type: string): any {
    this.tempFiles = [];

    for (const file of mediaFileArray) {
      if (type == 'Descriptive' || type == 'EditedSubtitle' || type == 'FinalSubtitle') {
        if (file.fileName.toLowerCase().match(this.regSub)) {
          this.tempFiles.push(file);
        }
      } else if (type == 'Transcoded') {
        if (file.fileName.toLowerCase().match(this.videoReg)) {
          this.tempFiles.push(file);
        }
      } else if (type == 'Audio') {
        if (file.fileName.toLowerCase().match(/\.(mp3|wav|aac|ogg|m4a)$/)) {
          this.tempFiles.push(file);
        }
      }
    }
  }

  timeSetter(program: Program): void {
    let fiftheen: number = 15 * 60 * 1000;
    let startTimeMod = program.startTime % 60000;
    this.startTime = program.startTime - startTimeMod;
    let start: number = this.startTime - fiftheen;
    for (let i = 0; i <= 30; i++) {
      let time = start + i * 60 * 3000;
      this.result.push(time);
    }
  }

  timestampToSecondConverter(timeToTranslate?: number): number {
    let result!: number;

    let time = new Date(timeToTranslate);

    result = time.getHours() * 60 * 60 + time.getMinutes() * 60 + time.getSeconds();

    return result;
  }

  regexSearch(files: any[], keyword: string[]): any {
    let tempFiles: any[] = [];
    for (const file of files) {
      if (keyword.includes('Audio')) {
        if (file.fileName.match(this.audioReg)) {
          tempFiles.push(file);
        }
      } else if (keyword.includes('Subtitle')) {
        if (file.fileName.match(this.regSub)) {
          tempFiles.push(file);
        }
      } else if (keyword.includes('trailer')) {
        if (!file.fileName.match(this.trailerRegex)) {
          tempFiles.push(file);
        }
      }
    }
    return tempFiles;
  }

  formatDate(date?: Date, count?: number): string {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + (count ? d.getDate() + count : d.getDate()),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  formatDateTime(date: Date): string {
    let d = new Date(date),
      hours = '' + d.getHours(),
      minutes = '' + d.getMinutes();

    if (hours.length < 10) hours = '0' + hours;
    if (minutes.length < 10) minutes = '0' + minutes;

    return [hours, minutes].join(':');
  }

  formatTime(time: any): string {
    console.table({ time });
    let h: any, m: any, s: any;
    h = time.hour;
    m = time.minute;
    if (h < 10) h = '0' + time.hour;
    if (m < 10) m = '0' + time.minute;
    // if (time.second < 10) s = '0' + time.second;
    return [h, m].join(':');
  }

  dateRangePickerInitializer(input: string): void {
    $(function () {
      let start = moment().subtract(29, 'days');
      let end = moment();

      function cb(start: any, end: any) {
        $(`#${input} span`).html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
      }

      $(`#${input}`).daterangepicker(
        {
          startDate: start,
          endDate: end,
          showDropdowns: true,
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          },
        },
        cb,
      );

      cb(start, end);
    });
  }

  persistTurkishCharacters(value: string): string {
    if (value.includes('%C4%B1')) {
      value.replace('%C4%B1', 'ı');
    }
    return value;
  }

  parseStringList(stringList: string): string[] {
    let list: string[] = stringList.split(',');
    return list.filter((str) => str.replace(/[\[\]']+/g, ''));
  }
  getValue(obj: Observable<any>) {
    let value: any;
    if (obj != null || obj != undefined) {
      obj.subscribe((v) => (value = v));
    }
    return value;
  }

  headerSetter(): void {
    let marker = document.getElementById('marker');
    if (marker == null) {
      let pxNav = document.getElementById('pxNavbar');
      let navbarHeader = pxNav.getElementsByClassName('navbar-header');
      let node = document.createElement('div');
      node.id = 'marker';
      node.classList.add('col-md-4');
      node.classList.add('align-items-center');
      let p = document.createElement('p');
      p.style.marginTop = '6px';
      p.style.fontSize = '20px';
      p.style.marginLeft = '75px';
      p.className = 'text-uppercase text-danger font-weight-bold';
      if (environment.staging) {
        p.innerHTML = 'STAGING';
      } else if (environment.development) {
        p.innerHTML = 'Development';
      }

      node.appendChild(p);
      navbarHeader[0].appendChild(node);
    }
  }

  dateInitializer(range: boolean, single: boolean): any {
    let thiz = this;
    $(function () {
      $("input[name='updateTime']").daterangepicer({
        autoUpdateInput: false,
        singleDatePicker: single,
        autoApply: false,
        locale: {
          cancelLabel: 'Clear',
        },
      });

      $("input[name='updateTime']").on('apply.daterangepicker', function (ev: any, picker: any) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
      });

      $("input[name='updateTime']").on('cancel.daterangepicker', function (ev: any, picker: any) {
        $(this).val('');
      });
    });
  }

  domElementRemover(element: string): void {
    let elements = document.getElementsByClassName(`${element}`);

    if (elements && elements.length > 0) {
      for (const element of elements) {
        let el = element as HTMLElement;
        el.remove();
      }
    }
  }

  getStartOfDay(date: Date): Date {
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);
    return start;
  }

  getEndOfDay(date: Date): Date {
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    return end;
  }

  formatHour(date: Date): string {
    let hours = date.getHours();
    let minutes = date.getMinutes();

    let formattedHours = hours < 10 ? '0' + hours : '' + hours;
    let formattedMinutes = minutes < 10 ? '0' + minutes : '' + minutes;

    return `${formattedHours}:${formattedMinutes}`;
  }

}
